import { createSelector } from 'reselect';
import { RoleEnum } from '../authRoles';
import { UserState } from './type';

const userSelector = (state: any): UserState => state.auth?.user || {};

export const userRoleSelector = createSelector(userSelector, user => user.role);

export const userDataSelector = createSelector(userSelector, user => user.data);

export const userLocationSelector = createSelector(userSelector, user => user.ipInfo);

export const userUberallSelector = createSelector(userSelector, user => user.data.uberall);

export const userPermissionsSelector = createSelector(userSelector, user => user.permissions);

export const isFranchiseOwnerSelector = createSelector(
  userSelector,
  user => user.data.acl?.role === RoleEnum.FRANCHISE_OWNER,
);

export const canSwitchFranchiseSelector = createSelector(
  userSelector,
  user => (user.reachableFranchisesCount || 0) > 1,
);
